module.exports = __webpack_public_path__ + "static/media/kadpolyLogo1.1ac8b56a.png";